import { Avatar } from 'primereact/avatar';
import avatar4 from '/avatar-04.jpg';
import logo from '/logo.svg';
import { Button } from "primereact/button";
import { IconMenu2, IconMoon, IconSun } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { logout } from '../auth/logout';
import { Menu } from 'primereact/menu';
import { useRef } from 'react';
import FontSizeSelector from '../components/font-size';
import FontFamilySelector from '../components/font-family.component';


type HeaderProps = {
  onToggle: () => void;
};

export default function Header({ onToggle }: HeaderProps) {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const items = [
    { label: "My Profile", icon: "pi pi-user", command: () => navigate("/my-profile") },
    { label: "Logout", icon: "pi pi-sign-out", command: logout, className: "logout-item" }
  ];
  const menu = useRef<Menu>(null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const username = userInfo?.username || "User";

  return (
    <div className="w-full min-h-16 bg-white dark:bg-gray-900 flex items-center justify-between px-6 sticky top-0 z-50 border-b border-gray-200 dark:border-gray-800 transition-colors duration-300">
      <div className="flex items-center gap-4">
        <Button onClick={onToggle} text={true} severity="secondary" rounded={true} icon={<IconMenu2 stroke={1.5} />} className="dark:text-white h-11! w-11! text-2xl! burgar-menu-button" />
        <img src={logo} className="w-auto h-8 cursor-pointer" onClick={() => navigate("/dashboard?callApi=true", { replace: true })} />
        {/* <h2 className="text-xl font-semibold">KAVACH Performance Analysis</h2> */}
      </div>
      <div className="flex items-center gap-4">

        <FontSizeSelector />

        <FontFamilySelector />

        <Button
          onClick={toggleTheme}
          rounded
          text
          severity="secondary"
          aria-label="Toggle Theme"
          className="p-1.5 hover:bg-gray-200 dark:hover:bg-gray-800"
          data-pr-tooltip={theme === 'light' ? 'Dark Mode' : 'Light Mode'}
          data-pr-position="bottom"
        >
          {theme === 'light' ? (
            <IconMoon size={24} />
          ) : (
            <IconSun size={24} color="white" />
          )}
        </Button>

        <div className="relative group">
          <Avatar onClick={(event) => menu.current?.toggle(event)} image={avatar4} shape="circle" imageAlt="admin" aria-controls="popup_menu" aria-haspopup className="cursor-pointer ring-2 ring-brand-100 hover:ring-brand-500 transition-all duration-200 ease-in-out" />
          <div className="pointer-events-none opacity-0 group-hover:opacity-100 transition duration-150 absolute right-full top-1/2 -translate-y-1/2 ml-3 z-[100000] bg-gray-900 text-gray-100 text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap">
            {username}
          </div>
        </div>
        <Menu popup ref={menu} model={items} id="popup_menu" popupAlignment="right" />
      </div>
    </div>
  );
}
